import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Pivot, PivotItem, PivotLinkSize } from '@fluentui/react/lib/Pivot';
import { currentSearchPivotKey } from '../selectors/searchViewSelectors';
import { setCurrentSearchPivotKey } from '../mutators/searchViewMutators';
import { getSearchableAssets } from 'owa-timestream-asset-search';
import ResultsFilter from './ResultsFilter';

import * as styles from './styles.scss';

export default observer(function PivotAndFilter() {
    const selectPivot = React.useCallback((item: PivotItem) => {
        setCurrentSearchPivotKey(item.props.itemKey);
    }, []);

    const searchableAssets = getSearchableAssets();
    const pivots = searchableAssets.map(searchableAsset => (
        <PivotItem
            key={searchableAsset.type}
            itemKey={searchableAsset.type}
            headerText={searchableAsset.getHeaderLabel()}
        />
    ));

    const selectedKey = currentSearchPivotKey();
    const firstSearchableAssetType = searchableAssets[0]?.type;
    React.useEffect(() => {
        if (!selectedKey && firstSearchableAssetType) {
            setCurrentSearchPivotKey(firstSearchableAssetType);
        }
    }, [selectedKey, firstSearchableAssetType]);

    return (
        <div className={styles.pivotAndFilter}>
            <Pivot
                className={styles.pivot}
                headersOnly={true}
                onLinkClick={selectPivot}
                linkSize={PivotLinkSize.normal}
                selectedKey={selectedKey}>
                {...pivots}
            </Pivot>
            <ResultsFilter />
        </div>
    );
});
